<template>
  <VuePerfectScrollbar class="scroll-area" infinite-wrapper>
    <div class="barChart" ref="barChartContainerDiv">
      <el-table
        :data="outgoingDocs"
        class="style-fullWidth"
        highlight-current-row
        sortable="custom"
        @sort-change="doSort"
        @row-click="viewDetail"
        ref="mainTable"
        :row-class-name="'item'"
      >
        <!-- :height="tableHeight" -->
        <!-- <el-table-column
          type="index"
          min-width="5"
          label="STT"
        ></el-table-column> -->

        <el-table-column width="50">
          <template #header>
            <el-checkbox
              v-if="hasExistChecked"
              :class="['checkboxVBan']"
              v-model="checkAll"
              @change="checkAllVBan"
            ></el-checkbox>
          </template>

          <template slot-scope="{ $index, row }">
            <span
              :class="checkHanOver(row) ? 'stt' : ''"
              v-if="!hasExistChecked"
            >
              {{ $index + 1 }}
            </span>
            <div
              v-if="checkHanOver(row)"
              :class="['checkbox', hasExistChecked ? '' : 'hover']"
            >
              <el-checkbox
                :class="['checkboxVBan']"
                v-model="row.checkVBan"
                @click.stop.native="() => true"
                @change="checked"
              ></el-checkbox>
            </div>
          </template>
        </el-table-column>

        <el-table-column min-width="5">
          <template slot-scope="scope">
            <is-seen-tag :isSeen="scope.row.isSeen"></is-seen-tag>
          </template>
        </el-table-column>

        <el-table-column
          :key="`Trích yếu + ${filterStatus}`"
          property="quote"
          label="Trích yếu"
          min-width="20"
          sortable
        >
          <template slot-scope="scope">
            <a
              class="custom-link-detail"
              :href="convertLinkToDetail(scope.row)"
              @click="stopProcess"
            >
              <break-word-span
                :text="scope.row.quote"
                :maxLength="200"
              ></break-word-span>
            </a>

            <br />

            <span v-if="scope.row.docCode"
              >#{{ scope.row.docCode }}&nbsp;&nbsp;</span
            >

            <el-tag v-if="scope.row.docTypeName"
              >{{ scope.row.docTypeName }}
            </el-tag>

            <doc-priority-tag
              :priorityName="scope.row.priorityName"
            ></doc-priority-tag>
          </template>
        </el-table-column>

        <el-table-column
          :key="`Trạng thái + ${filterStatus}`"
          property="status"
          label="Trạng thái"
          sortable
          v-if="isDisplayField('status')"
          align="left"
          min-width="15"
        >
          <template slot-scope="scope">
            <doc-out-status-tag
              v-if="scope.row.status != null"
              :status="scope.row.status"
            ></doc-out-status-tag>
          </template>
        </el-table-column>

        <el-table-column
          :key="`Người chuyển + ${filterStatus}`"
          property="senderFullName"
          label="Người chuyển"
          sortable
          min-width="15"
          v-if="isDisplayField('senderFullName')"
        >
          <template slot-scope="scope">
            <break-word-span
              :text="scope.row.senderFullName"
              :maxLength="100"
            ></break-word-span>
          </template>
        </el-table-column>

        <el-table-column
          :key="`Thời gian xử lý + ${filterStatus}`"
          property="updateTime"
          label="Thời gian xử lý"
          sortable
          v-if="isDisplayField('updateTime')"
          align="left"
          min-width="15"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime | dateFormatter({ nullValue: "-" }) }}
          </template>
        </el-table-column>

        <el-table-column
          :key="`Ngày tạo + ${filterStatus}`"
          property="createTime"
          label="Ngày tạo"
          sortable
          v-if="isDisplayField('createTime')"
          align="left"
          min-width="15"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatter({ nullValue: "-" }) }}
          </template>
        </el-table-column>

        <el-table-column
          :key="`Thời gian chuyển + ${filterStatus}`"
          property="processTime"
          label="Thời gian chuyển"
          sortable
          v-if="isDisplayField('processTime')"
          align="right"
          min-width="10"
        >
          <template slot-scope="scope">
            {{ scope.row.processTime | dateFormatter({ nullValue: "-" }) }}
          </template>
        </el-table-column>

        <infinite-loading
          slot="append"
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </el-table>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import dateFormatter from "../../filters/dateFormatter";
import SortCaret from "./SortCaret";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import DocOutStatusTag from "./doc-out-status-tag";
import DocPriorityTag from "../common/doc-priority-tag";
import infiniteLoading from "vue-infinite-loading";
import constants from "../../constants";
import vbOutgoingDocUserViewService from "../../services/vbOutgoingDocUserViewService";
import utils from "../../services/utils";
import IsSeenTag from "../common/is-seen-tag";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "doc-out-main-content",
  props: [
    "sort",
    "order",
    "advanceSearchForm",
    "displayFields",
    "listOutgoingDocs",
    "checkPermissionHandOver",
    "filterStatus",
  ],
  components: {
    IsSeenTag,
    DocPriorityTag,
    DocOutStatusTag,
    BreakWordSpan,
    SortCaret,
    infiniteLoading,
    VuePerfectScrollbar,
  },
  filters: { dateFormatter },
  computed: {
    hasExistChecked() {
      return this.countVbanChecked > 0;
    },
  },
  data() {
    return {
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      outgoingDocs: [],
      outgoingDocsCount: null,
      page: 0,
      size: 10,
      tableHeight: null,

      countVbanChecked: 0,
      checkAll: false,
    };
  },

  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.mainTable.$el.offsetTop - 140;
  },

  watch: {
    listOutgoingDocs(newValue) {
      this.countVbanChecked = newValue.length;
    },
  },

  methods: {
    convertLinkToDetail(item) {
      return `${window.location.origin}/#/app/${this.$store.getters.userDeptRoleId}/vbDuThaoNew/detail/${item.id}?filterStatus=${this.$route.query.filterStatus}`;
    },

    stopProcess(e) {
      e.preventDefault();
    },

    checkHanOver(row) {
      return (
        row.creatorId === this.$store.getters.user.id &&
        this.checkPermissionHandOver
      );
    },
    checkAllVBan(value) {
      !value && (this.countVbanChecked = 0);
      this.outgoingDocs.forEach((item) => {
        if (value) {
          this.$set(item, "checkVBan", value);
          this.countVbanChecked += 1;
        } else if (!value) {
          this.$set(item, "checkVBan", value);
        }
      });
      let listChecked = this.outgoingDocs.filter(
        (doc) => doc.checkVBan && doc.creatorId === this.$store.getters.user.id
      );
      this.$emit(
        "changeSelectedRow",
        listChecked.map((item) => item.id)
      );
    },

    checked(value) {
      this.countVbanChecked += value ? 1 : -1;
      this.checkAll =
        this.countVbanChecked ===
        this.outgoingDocs.filter(
          (doc) => doc.creatorId === this.$store.getters.user.id
        ).length;
      let listChecked = this.outgoingDocs.filter((doc) => doc.checkVBan);
      this.$emit(
        "changeSelectedRow",
        listChecked.map((item) => item.id)
      );
    },

    isDisplayField(fieldName) {
      return (this.displayFields || []).indexOf(fieldName) !== -1;
    },

    deleteDoc(item) {
      this.$emit("deleteDoc", item);
    },

    doSort(event) {
      let { order, sort } = utils.convertElTableSortEvent(event);
      this.$emit("doSort", { order: order, sort: sort });
    },

    doSearch() {
      this.outgoingDocs = [];
      this.page = 0;
      if (this.$refs.infiniteLoading)
        this.$refs.infiniteLoading.stateChanger.reset();
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(","),
      };
      let docStatus =
        !this.advanceSearchForm.docStatus &&
        this.advanceSearchForm.docStatus !== 0
          ? [
              constants.OUTGOING_DOC_STATUS.TAOMOI,
              constants.OUTGOING_DOC_STATUS.DANGXULI,
              constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
              constants.OUTGOING_DOC_STATUS.TU_CHOI,
              constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH,
            ]
          : [this.advanceSearchForm.docStatus];
      let relationType;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
          break;
        case constants.DU_THAO_PAGE.FILTER.PHOI_HOP:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_PHOI_HOP;
          break;
        default:
          relationType = null;
      }
      let status;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.CHO_XU_LY:
          status = constants.DOC_USER_STATUS.CHO_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.DA_XU_LY:
          status = constants.DOC_USER_STATUS.DA_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.ALL:
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
        default:
          status = -1;
          break;
      }
      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        docStatus: docStatus,
        relationType: relationType,
        status: status,
      });
      return vbOutgoingDocUserViewService
        .findAll2(advanceSearchForm, pageable)
        .then((response) => {
          let items = response.data;
          console.log(items);
          items && this.outgoingDocs.push(...items);
          return items;
        });
    },

    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    isSeen(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen === 1) return "";
        else return "is-seen";
      } else return "";
    },

    viewDetail(item) {
      item.isSeen = 1;
      this.$emit("viewDetail", item);
    },
  },
};
</script>

<style scoped>
.barChart {
  /*margin-top: 20px;*/
  width: calc(100% - 10px) !important;
  position: relative;
}

.scroll-area {
  max-height: 100% !important;
}

.el-table >>> th > .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
}

.el-table >>> td > .cell {
  text-overflow: clip;
}

.item .checkbox.hover {
  display: none;
}

.item:hover .stt {
  display: none;
  transition: 0.5s;
}

.item:hover .checkbox.hover {
  display: flex;
  transition: 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/doc-out-main-content.vue